import { TvvBesteldeRoute, TvvBus } from "@/entities/tvv/domain/tvv-bestelde-route.ts";
import { AfgeschaaldeBussen } from "@/features/tvv/components/shared/afgeschaalde-bussen.tsx";
import { Icon, Separated } from "@/shared/components/ui";
import { formatDateTimeRelative } from "@/shared/utils";

type StationEtaDisplayProps = {
    stationNaam: string;
    aantalBussen: number;
    bussen: TvvBus[];
    etasPubliek: boolean;
    ["data-testid"]?: string;
};

export function StationEtaDisplay({
    stationNaam,
    aantalBussen,
    bussen,
    etasPubliek,
    "data-testid": dataTestId,
}: Readonly<StationEtaDisplayProps>) {
    const [actieveBussen, afgeschaaldeBussen] = TvvBesteldeRoute.actieveAndAfgeschaaldeBussen({ bussen });

    return (
        <div className="space-y-2" data-testid={dataTestId}>
            <div className="text-content-subtle text-s font-bold">
                {stationNaam} ({actieveBussen.length}/{aantalBussen})
            </div>
            {bussen.length === 0 ? (
                <div className="text-content-subtle text-s">Er zijn nog geen ETAs voor {stationNaam} bekend</div>
            ) : (
                <div className="space-y-1">
                    <Separated orientation="vertical">
                        {actieveBussen.map((bus, index) => (
                            <div
                                key={`eta-${index}-${bus.tijd.getTime()}`}
                                className="text-s flex items-center gap-2"
                                data-testid={`bus-eta-${index + 1}`}
                            >
                                <Icon name="bus" className="text-content-emphasis h-6 w-6" />
                                <span className="text-content-emphasis pl-2 font-medium">{index + 1}</span>
                                <div className="text-content-subtle text-s ml-auto flex flex-col text-right">
                                    <span className="text-content-subtle text-s ml-auto" data-testid="eta-tijd">
                                        ETA {formatDateTimeRelative(bus.tijd)}
                                    </span>
                                    <span
                                        className={`flex items-center gap-1 ${etasPubliek ? "text-content-default" : "text-content-subtle"}`}
                                        data-testid="eta-wissel-bandbreedte"
                                    >
                                        <Icon
                                            size="xs"
                                            name={etasPubliek ? "megaphone" : "megaphone-conflict"}
                                            className={etasPubliek ? "text-content-emphasis" : "text-content-subtle"}
                                        />
                                        Wissel: {bus.bandbreedte}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </Separated>
                    <AfgeschaaldeBussen bussen={afgeschaaldeBussen} />
                </div>
            )}
        </div>
    );
}
